<template>
  <div id="my-analytics" class="view">
    <!-- head -->
    <div class="header">
      <div class="i-header-btn" @click="back">
        <i class="fal fa-chevron-left"></i>
        <div class="txt">뒤로</div>
      </div>
    </div>

    <div class="content scroll">
      <div class="head">
        <div class="lab">지출</div>
        <div class="val">{{ $filters.numberFormat(spend) }}</div>
      </div>

      <ul class="list">
        <li class="i-spen-anal" v-for="(item, index) in data" :key="index">
          <div class="item">
            <div class="lab">{{ item.name }}</div>
            <div class="data">
              <div class="graph">
                <div
                  class="pointer"
                  v-bind:style="{ width: item.percent + '%' }"
                ></div>
              </div>
            </div>
            <div class="per">{{ item.percent }}%</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "MyAnalytics",
  components: {},
  data() {
    return {
      spend: "1366000",
      data: [],
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
  created() {},
  mounted() {
    this.$api
      .getUserSpendStatic({
        user_token: this.$user.getToken(),
      })
      .then((rs) => {
        console.log("sta", rs);
        this.spend = rs.info.total_spend_price;
        for (let idx in rs.list) {
          var item = rs.list[idx];
          item.percent = ((item.total_price / this.spend) * 100).toFixed(1);
        }
        this.data = rs.list;
      });
  },
};
</script>
<style scoped>
.head {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  margin-top: 16px;
}
.head .lab {
  font-size: 29px;
  font-weight: bold;
  color: black;
}
.head .val {
  margin-left: auto;
  font-size: 22px;
  font-weight: bold;
  color: rgb(48, 48, 48);
}

.list {
  margin-top: 20px;
}
.i-spen-anal {
  padding: 5px 24px;
}
.i-spen-anal .item {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.i-spen-anal .item .lab {
  min-width: 100px;

  font-size: 18px;
  font-weight: bold;
  color: rgb(48, 48, 48);

  text-align: left;
}
.i-spen-anal .item .data {
  width: 100%;
}
.i-spen-anal .item .data .graph {
  height: 13px;
  width: 100%;  
  overflow: hidden;
}
.i-spen-anal .item .data .graph .pointer {
  width: 20px;
  height: 100%;
  background: #ff5600;
  border-radius: 5px;
}

.i-spen-anal .item .per {
  min-width: 100px;
  text-align: right;
  font-size: 16px;
  font-weight: bold;
  color: rgb(48, 48, 48);
}
</style>